// Copyright 2026. WebPros International GmbH. All rights reserved.

import { api } from 'common/api/resources/Response';
import { IMassMailUsersRequest } from 'common/api/resources/MassMailing';

export const massMailing = {
    post: (data: IMassMailUsersRequest) => api.post('/mass-mailing', {
        ...data,
    }),
};